<app-pwd-reset-email-entry *ngIf="currentStep === ResetStep.EmailEntry" (parentUpdate)="handleUpdate($event)"
                           [errorKey]="errorKey" [prefillUsername]="prefillUsername">
</app-pwd-reset-email-entry>
<app-pwd-reset-email-sent *ngIf="currentStep === ResetStep.EmailSent" (parentUpdate)="handleUpdate($event)">
</app-pwd-reset-email-sent>
<app-pwd-reset-enter-password *ngIf="currentStep === ResetStep.EnterPassword && token" [token]="token"
                              (parentUpdate)="handleUpdate($event)">
</app-pwd-reset-enter-password>
